$(document).ready(function() {
	if (window.location.pathname.search('//products\/\w+\/\^/') !== 1 ) {

		//$('form.vtajaxform').unbind('submit');
	}
});